module.exports = __webpack_public_path__ + "static/img/liu.b91558d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/liu.png
// module id = maeL
// module chunks = 1